import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldType } from '../../Common/Types/Field'
import Dropdown from '../../Common/Components/Dropdown'

const options = [
  { value: 'PCM3', label: 'PCM3' },
  { value: 'IHP', label: 'IHP' },
]

const DeviceTypeDropdown = ({ value, onChange, required, error, helperText, ...other }) => {
  const { t } = useTranslation()

  return (
    <Dropdown
      label={t('common:fields.deviceType')}
      required={required}
      value={value}
      onChange={onChange}
      options={options}
      error={error}
      helperText={helperText}
      {...other}
    />
  )
}

DeviceTypeDropdown.defaultProps = {
  required: false,
}

DeviceTypeDropdown.propTypes = FieldType

export default DeviceTypeDropdown
